import { action } from 'easy-peasy';
import { IActionStartCrisisVisit } from '../types';
import { matchesAllocation, recalculateCrisisStatus } from './helpers';

const startCrisisVisit: IActionStartCrisisVisit = action(
  (state, { userId, clientId, crisisCallId, startTimeUtc }) => {
    if (!crisisCallId && !clientId) {
      return;
    }

    const teamMembers = !crisisCallId
      ? state.crisisCallTeamMembers.filter(member => member.id === userId)
      : state.crisisCallTeamMembers;

    teamMembers.forEach(teamMember => {
      let wasUpdated = false;

      teamMember.allocatedClients.forEach(allocation => {
        if (matchesAllocation(allocation, clientId, crisisCallId)) {
          allocation.visitStartTime = startTimeUtc;
          wasUpdated = true;
        }
      });

      if (wasUpdated) {
        recalculateCrisisStatus(teamMember);
      }
    });
  },
);

export default startCrisisVisit;
